import { render, staticRenderFns } from "./EditContactForm.vue?vue&type=template&id=27fa3866&scoped=true&"
import script from "./EditContactForm.vue?vue&type=script&lang=js&"
export * from "./EditContactForm.vue?vue&type=script&lang=js&"
import style0 from "./EditContactForm.vue?vue&type=style&index=0&id=27fa3866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa3866",
  null
  
)

export default component.exports